import { useState, useCallback, useMemo } from 'react';
import useSSE from '../../../hooks/useSSE';
import { SSE_URL } from '../constants';

export function useNotificationsCount() {
  const backendApi = import.meta.env.VITE_APP_NOTIFICATION_ENDPOINT;
  const {
    data,
    error,
    isConnecting,
    isOpen: isConnectionOpen,
    isClosed: isConnectionClosed,
    connect,
    disconnect,
    reconnect,
  } = useSSE(`${backendApi}${SSE_URL}`, {
    headers: {
        Authorization: `Bearer ${localStorage.token}`,
      },
    autoReconnect: true,
    maxReconnectAttempts: 3,
    reconnectInterval: 3000,
    withCredentials: false,
  });

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      setAnchorEl(event.currentTarget);
    },
    []
  );

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);
  const notificationCount = data?.count;
  const count = useMemo(() => (typeof notificationCount === 'number' ? notificationCount : 0), [notificationCount]);
  const isModalOpen = Boolean(anchorEl);
  
  return {
    anchorEl,
    isModalOpen,
    count,
    error,
    isConnecting,
    isConnectionOpen,
    isConnectionClosed,
    connect,
    disconnect,
    reconnect,
    handleClick,
    handleClose,
  };
}